import { render, staticRenderFns } from "./SvgIconBase.vue?vue&type=template&id=02f4ff7f&"
import script from "./SvgIconBase.vue?vue&type=script&lang=js&"
export * from "./SvgIconBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports